import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { EMPTY_EDI_MONITORING_SEARCH_CRITERIA } from "presentation/constant/EdiMonitoring/EdiMonitoringSearchCriteria";
import { useEdiMonitoringVM } from "presentation/hook/EdiMonitoring/useEdiMonitoringVM";
import { useEdiMonitoringTracked } from "presentation/store/EdiMonitoring/EdiMonitoringProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import EdiMonitoringTitleBar from "./EdiMonitoringTitleBar";
import EdiMonitoringSearchPanel from "./LeftPanel/EdiMonitoringSearchPanel";
import EdiMonitoringTablePanel from "./Table/EdiMonitoringTablePanel";


const EdiMonitoringMaintenance: React.FC = () => {
    const [ediMoniState] = useEdiMonitoringTracked();
    const { isShowCriteriaPanel } = ediMoniState;
    const ediMoniVM = useEdiMonitoringVM();
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        ediMoniVM.setIsSearchLoading(true);
        const initialScreen = async () => {
            const results = await Promise.allSettled([
                ediMoniVM.loadDropdownOption(),
            ]);
            results?.forEach((result, index) => {
                if (index === 0 && result.status === 'fulfilled') {

                }
            })
        }
        initialScreen().then(() => {
            let newSearchCriteria = {
                ...EMPTY_EDI_MONITORING_SEARCH_CRITERIA,
                sentDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                sentDateTo: moment().endOf("day").toDate(),
            };
            ediMoniVM.onSearch(newSearchCriteria);
        }).then((data) => {
            setIsLoading(false);
            ediMoniVM.setIsSearchLoading(false);
        }).catch(error => {
            setIsLoading(false);
            ediMoniVM.setIsSearchLoading(false);
        });

    }, [ediMoniVM])



    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;
    return <>
        <div className={`main-comp-wrapper${(isShowCriteriaPanel) ? '' : ' im-hide-side-form-draggable'}`}>
            <EdiMonitoringTitleBar />

            <SliderPanel
                isOpen={true}
                draggable={false}
                leftSectionWidth={isShowCriteriaPanel ? "22%" : "0%"}
                rightSectionWidth={isShowCriteriaPanel ? "78%" : "100%"}
                leftChildren={<EdiMonitoringSearchPanel />}
                rightChildren={<EdiMonitoringTablePanel />}
            />
        </div>
    </>
}

export default memo(EdiMonitoringMaintenance);